function Analysis() {
  return (
    <div>
      <h1>分析</h1>
    </div>
  );
}
export default Analysis;
